import $ from "jquery";

$(".accordion").each(function () {
    $(this).find('[data-bs-toggle="collapse"]').on('click', function (e) {
        setTimeout(function () {
            if ($(e.currentTarget).attr('aria-expanded') !== 'true') {
                history.replaceState({}, "", ' ')
            } else {
                history.replaceState({}, "", $(this).data('bs-target'))
            }
        }.bind(this), 100)
    })

    if (window.location.hash) {
        setTimeout(function () {
            let $accordionCollapse = $(window.location.hash + ".accordion-collapse")

            if ($accordionCollapse.length) {
                bootstrap.Collapse.getOrCreateInstance(
                    $accordionCollapse[0]
                ).show()
            }
        }, 0);
    }
})

$('.accordion-button').on('click', function () {
    var accordionItem = $('.accordion-item');

    accordionItem.removeClass('active');
    accordionItem.removeClass('completed');

    var currentItem = $(this).closest('.accordion-item');

    if ($(this).attr('aria-expanded') === 'true') {
        currentItem.addClass('active');
        currentItem.prevAll('.accordion-item').addClass('completed');
    }
});

$(".blocks_accordion .accordion .collapse").removeClass("show");
$(".blocks_accordion .accordion .accordion-header")
    .addClass("collapsed")
    .attr("aria-expanded", "false");
$(".blocks_accordion .accordion").css("visibility", "visible").hide().fadeIn(100);


$('.blocks_documents a').each(function () {
    var $link = $(this);
    var href = $link.attr('href');
    var fileExtension = href.split('.').pop().toLowerCase();

    $link.wrap('<div class="doc-wrap"></div>');

    // Default icon for regular links
    var iconClass = 'fa-link';

    // File type icons
    switch (fileExtension) {
        case 'docx':
        case 'doc':
            iconClass = 'fa-file-word';
            break;
        case 'pdf':
            iconClass = 'fa-file-pdf';
            break;
        case 'xlsx':
        case 'xls':
            iconClass = 'fa-file-excel';
            break;
        case 'zip':
        case 'rar':
            iconClass = 'fa-file-archive';
            break;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            iconClass = 'fa-file-image';
            break;
        default:
            iconClass = 'fa-link';
    }

    var $linkWrap = $link.closest('.doc-wrap');

    $linkWrap.html(`
            <div class="icon-wrapper">
                <i class="fas ${iconClass}"></i>
            </div>
            <div class="file-details">
                <a href="${href}" class="url" target="_blank"></a>
                <span class="file-name">${$link.text()}</span>
                <span class="file-size fw-normal"></span>
            </div>
        `).prepend($linkWrap);

    // Set up AJAX call for file size
    if (['docx', 'doc', 'pdf', 'xlsx', 'xls', 'zip', 'rar', 'jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
        $.ajax({
            url: href,
            type: 'HEAD',
            success: function (data, status, xhr) {
                var fileSize = xhr.getResponseHeader('Content-Length');

                if (fileSize) {
                    // Convert bytes to KB/MB
                    var sizeKB = (fileSize / 1024).toFixed(2);
                    var sizeText = sizeKB > 1024 ? (sizeKB / 1024).toFixed(2) + ' MB' : sizeKB + ' KB';

                    $linkWrap.find('.file-size').text(sizeText);
                }
            }
        });
    }
});